<template>
  <div class="campaign-form-container">
    <v-container>
      <v-layout row class="padding">
        <v-flex xs4 sm12 offset-sm3>
          <v-card
            class="mx-auto mt-4 pa-5 text-center text-no-wrap"
            max-width="1000"
            id="limited-products"
          >
            <v-data-table
              :headers="headers"
              :items="items"
              :search="search"
              sort-by="calories"
              class="elevation-1"
            >
              <template v-slot:top>
                <v-toolbar flat>
                  <div class="col-md-3 col-6">
                    <v-text-field
                      v-model="search"
                      append-icon="mdi-magnify"
                      label="Search"
                      outlined
                      dense
                      hide-details
                    ></v-text-field>
                  </div>
                  <div class="col-md-3 col-6">
                    <h2 style="color:#e19813"><u>{{title}}</u></h2>
                  </div>
                  <v-spacer></v-spacer>
                   <div class="compaign-container">
                    <v-btn class="campaign-btn" @click="back"
                      >Back</v-btn
                    >
                  </div>
                </v-toolbar>
              </template>
              <template v-slot:[`item.trial_start_date`]="{ item }">
                {{ item.trial_start_date?item.trial_start_date:'N/A' }}
              </template>
              <template v-slot:[`item.plan`]="{ item }">
                {{ item.plan?item.plan:'N/A' }}
              </template>
              <template v-slot:[`item.payment_status`]="{ item }">
                {{ item.payment_status?item.payment_status:'N/A' }}
              </template>
              <template v-slot:[`item.paid_amount`]="{ item }">
                {{ item.paid_amount?item.paid_amount:'N/A' }}
              </template>
            </v-data-table>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data: () => ({
    search: "",
    headers: [
      { text: "Name", value: "name" },
      
    ],
    items: [],
  }),

  created() {
    this.initialize();
  },
  mounted() {},

  methods: {
      back() {
      this.$router.push({ name: "BusinessDashboard" }).catch(() => {});
    },
    addCampaigntopic() {
      this.$router.push({ name: "CampaignTopicForm" }).catch(() => {});
    },
    initialize() {
      this.$loading(true);
      let name = this.$route.params.name;
      this.items = [];
      let token = localStorage.getItem("token");
      axios
        .get(process.env.VUE_APP_ROOT_API + "admin/users/"+name, {
          headers: {
            Authorization: "Bearer " + token,
          },
        })
        .then((response) => {
          this.$loading(false);
          this.items = response.data.usersData;
          this.title = response.data.title;
        });
    },
  },
};
</script>
<style>

.active-class {
  color: rgb(35, 199, 35);
  font-size: 16px;
  font-weight: bold;
}
.inactive-class {
  font-size: 16px;
  font-weight: bold;
  color: dimgrey;
}
</style>